import { render, staticRenderFns } from "./ModalTabelaAgend.vue?vue&type=template&id=fbf372fc&"
import script from "./ModalTabelaAgend.vue?vue&type=script&lang=js&"
export * from "./ModalTabelaAgend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports